const UA = navigator.userAgent //获取UA
const ua = navigator.userAgent.toLowerCase() //获取ua

/**
 * 获取当前环境，图片CDN使用
 */
const env = window.location.host.split('.')[0].split('-').pop() || ''
export const cur = window.location.port
  ? '-dev'
  : ['dev', 'test', 'stg'].includes(env)
  ? `-${env === 'dev' ? 'test' : env}`
  : env.indexOf('localhost') !== -1
  ? '-dev'
  : ''

export const fxResource = window.location.port
  ? 'dev'
  : ['dev', 'test', 'stg'].includes(env)
  ? `dev`
  : env.indexOf('localhost') !== -1
  ? 'dev'
  : 'prod'

/**
 * 获取当前环境，登录使用
 */
export const ucur = ['dev', 'test', 'stg'].includes(env)
  ? `-${env === 'dev' ? 'test' : env}`
  : env.indexOf('localhost') !== -1
  ? '-test'
  : ''

/**
 * 获取当前环境，fx namespace使用
 */
export const fxCur = ['dev', 'test', 'stg'].includes(env)
  ? env
  : env.indexOf('localhost') !== -1
  ? 'test'
  : 'prod'

/**
 * 当前环境是否为微信
 */
export const isWX = /(?:MicroMessenger)/.test(UA)

/**
 * 当前环境是否为微博
 */
export const isWB = /(?:weibo)/.test(ua)

export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)

export const isInApp = [
  "nio-lifestyle",
  "Lifestyle",
  "niopower",
  "NIOPower",
  "NioPower",
  "_dsbridge",
  "webview/lg"
].some((flag) => ua.indexOf(flag) > -1);
